// extracted by mini-css-extract-plugin
export var header = "_wl-1";
export var maskBottom = "_wl-6";
export var maskMiddle = "_wl-7";
export var maskTop = "_wl-5";
export var root = "_wl-0";
export var scrollDownButton = "_wl-3";
export var scrollDownButtonHidden = "_wl-4";
export var viewport = "_wl-2";